import { Injectable, Injector } from "@angular/core";
import { FrameContext } from "@farris/devkit";
import { EMPTY } from "rxjs";
import { AttentionService, AttentionElement } from '@farris/ui-tooltip';


@Injectable()
export class FormAttentionService {
  constructor(private injector: Injector, private frameContext: FrameContext, private attentionService: AttentionService) { }
  /**
   * éªçæé®
   * @param ids idå­ç¬¦ä¸²ææ°ç»
   * @param duration æ¶é´é´é
   * @returns 
   */
  public blink(ids: string | string[], duration?: any) {
    if (typeof ids === 'string') {
      ids = ids.split(',').filter(p => p);
    }
    if (!Array.isArray(ids) || ids.length < 1) {
      return EMPTY;
    }
    if (typeof duration === 'string') {
      duration = duration.trim();
    }
    if (!duration) {
      duration = 600;
    }
    duration = parseInt(duration);
    if (isNaN(duration) || duration <= 0) {
      duration = 600;
    }
    const elements: AttentionElement[] = ids.map((item: string) => {
      return {
        idOrEl: item,
        // type:'',
        // class:''
      };
    });
    this.attentionService.catchAttention(elements, duration);
  }
}